import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const formatDate = (date) => {
  const day = ('0' + date.getDate()).slice(-2)
  const month = ('0' + (date.getMonth()+1)).slice(-2)
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

export const useGSTStore = defineStore('gststore', () => {
  // Store Models
  const annual_expected_list = [
    "$0 to $74,999",
    "$75,000 to $149,999",
    "$150,000 to $1,999,999",
    "$2 million to $9,999,999",
    "$10 million to $19,999,999",
    "$20 million and over",
  ]
  const import_goods    = ref(false)
  const start_at        = ref(formatDate(new Date))
  const annual_expected = ref("$0 to $74,999")
  const company_lodge   = ref("Annually")
  const cash_basis      = ref("Cash")
  const do_bn           = ref(false)

  const resetData = () => {
    import_goods.value    = false
    start_at.value        = formatDate(new Date())
    annual_expected.value = '$0 to $74,999'
    company_lodge.value   = 'Annually'
    cash_basis.value      = 'Cash'
    do_bn.value           = false
  }

  const update = (order) => {
    import_goods.value    = !!order.gst.import_goods
    start_at.value        = order.gst.start_at
    annual_expected.value = order.gst.annual_expected
    company_lodge.value   = order.gst.company_lodge
    cash_basis.value      = order.gst.cash_basis
    do_bn.value           = !!order.business_name
  }

  return {
    annual_expected,
    annual_expected_list,
    company_lodge,
    cash_basis,
    import_goods,
    start_at,
    do_bn,
    resetData,
    update,
  }
}, { persist: true, })
